import type { BaseElement } from 'slate';

import type { AlineText, SuggestedBreakEdit } from '../../internal';

export type Break = 'break';
export const breakType: Break = 'break';

export enum BreakVariant {
  Page = 'page',
}

export interface BreakElement extends BaseElement {
  children: AlineText[];
  type: Break;
  variant: BreakVariant;
  suggestedEdits?: SuggestedBreakEdit[] | null;
}

export interface PageBreakElement extends BreakElement {
  variant: BreakVariant.Page;
}

export type PageBreakProps = Omit<PageBreakElement, 'children'>;
